import { render } from "./FormMessage.vue?vue&type=template&id=230da39a&scoped=true"
const script = {}

import "./FormMessage.vue?vue&type=style&index=0&id=230da39a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230da39a"]])

export default __exports__